import type { AgentRuntimePolicy, JsonObject } from "../../../../../packages/shared-types/src/index.js";

export type ControlPlaneAgentStatus = "draft" | "active" | "paused";
export type ControlPlaneAgentPromptKey =
  | "AGENTS.md"
  | "SOUL.md"
  | "IDENTITY.md"
  | "USER.md"
  | "SOURCE.md"
  | "CHANNEL.md";

export type ControlPlaneAgentPromptDocument = {
  tenantId: string;
  agentId: string;
  key: ControlPlaneAgentPromptKey;
  contentMarkdown: string;
  version: number;
  contentHash: string;
  updatedAtUtc: string;
  updatedBy: string;
};

export const AGENT_INSTRUCTIONS_PROMPT_KEY = "AGENTS.md" satisfies ControlPlaneAgentPromptKey;
export const AGENT_SOUL_PROMPT_KEY = "SOUL.md" satisfies ControlPlaneAgentPromptKey;
export const AGENT_IDENTITY_PROMPT_KEY = "IDENTITY.md" satisfies ControlPlaneAgentPromptKey;
export const AGENT_USER_PROMPT_KEY = "USER.md" satisfies ControlPlaneAgentPromptKey;

export type ControlPlaneAgentRecord = {
  tenantId: string;
  agentId: string;
  name: string;
  slug?: string;
  status?: ControlPlaneAgentStatus;
  description?: string;
  promptDocuments: ControlPlaneAgentPromptDocument[];
  channelOverlays?: Record<string, JsonObject>;
  runtimePolicy: AgentRuntimePolicy;
  updatedAt: string;
};

export function readAgentPromptDocument(
  agent: Pick<ControlPlaneAgentRecord, "promptDocuments"> | undefined,
  key: ControlPlaneAgentPromptKey,
): string {
  return agent?.promptDocuments?.find((document) => document.key === key)?.contentMarkdown ?? "";
}

export function promptDocumentWrite(
  key: ControlPlaneAgentPromptKey,
  contentMarkdown: string,
) {
  return {
    key,
    contentMarkdown: contentMarkdown.trim(),
  };
}
